import { useQuery } from '@apollo/client';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import React from 'react';

import {
  GetUserQueryGQLType,
  GetUserQueryVariablesGQLType,
} from 'types/dashboard-core-gqlTypes.generated.d';

import { getGreetingForTime } from 'packages/common-frontend/utils';
import { useAuthToken } from 'packages/logged-out/hooks/useAuthManagement';
import { AiFillCheckCircle } from 'react-icons/ai';
import { GET_USER } from 'requests/queries.gql';

import 'source/borrower/borrower.scss';

const CompletedStepItem = ({
  stepLabel,
  bottomRow,
}: {
  stepLabel: string;
  bottomRow?: boolean;
}) => {
  return (
    <Flex alignItems="center">
      <Icon
        color="#25ba86"
        as={AiFillCheckCircle}
        marginRight="12px"
        fontSize="28px"
        mb={bottomRow ? 0 : '20px'}
      />
      <Text
        className="side-bar-item"
        fontSize="16px"
        w="100%"
        borderBottom={bottomRow ? 'none' : '1px solid #e3e3e3'}
        mb={bottomRow ? 0 : '10px'}
        pb={bottomRow ? 0 : '10px'}
      >
        {stepLabel}
      </Text>
    </Flex>
  );
};

CompletedStepItem.defaultProps = {
  bottomRow: false,
};

export const BorrowerHomeView = () => {
  const [authToken] = useAuthToken();
  const { data: userData } = useQuery<
    GetUserQueryGQLType,
    GetUserQueryVariablesGQLType
  >(GET_USER, {
    context: {
      headers: {
        authorization: `Bearer ${authToken}`,
      },
    },
  });

  let borrowerName = '';
  let greeting = getGreetingForTime();

  if (userData && userData.user) {
    const { user } = userData;
    greeting = `${greeting}, ${user.firstName}`;
    borrowerName = user.organization.name;
  }
  return (
    <>
      <Box fontSize={{ base: '16px', sm: '20px', md: '24px' }}>{greeting}</Box>
      <Text fontSize={{ base: '8px', sm: '12px', md: '16px' }} color="gray">
        {borrowerName}
      </Text>
      <Box mt="30px" fontSize={{ base: '12px', sm: '16px' }}>
        Finley setup progress:
      </Box>
      <Box border="1px solid #e3e3e3" marginTop="6px" padding="14px 11px">
        <CompletedStepItem stepLabel="Credit agreement digitized" />
        <CompletedStepItem stepLabel="Borrowing base reports automated" />
        <CompletedStepItem stepLabel="Monthly reports automated" bottomRow />
      </Box>
    </>
  );
};
